import { useSubscription } from "@apollo/client";
import { ORCH_PROJECT_UPDATE } from "graphql/subscriptions";

export function useAutomationSubscription(taskId: string) {
    //todo: https://github.com/apollographql/apollo-feature-requests/issues/252
    return useSubscription<AutomationSubSubscriptionData, AutomationSubscriptionVariables>(ORCH_PROJECT_UPDATE, {
        variables: { taskId }
    });
}

export type AutomationUpdate = {
    taskId: string;
    actionId?: string;
    hubName: string;
    functionName: string;
    instanceId: string;
    reason: string;
    runtimeStatus: string;
    eventType: string;
    actionCompletedOutput?: Array<any>;
    projectOutput?: string;
    error?: string;
    skipped?: string;
    canceled?: string;
};

type AutomationSubscriptionVariables = {
    taskId: string;
};

type AutomationSubSubscriptionData = {
    orchProjectUpdate: AutomationUpdate;
    document: Document;
};
